'use client';

import { Box, VStack } from '@terra/ui-styled-system';
import type { ReactNode } from 'react';
import { MetaDefault } from '../../components/typography';
import { EmptyState } from '../empty-state/EmptyState';

type SettingsEmptyStateProps = {
  children: ReactNode;
  action?: ReactNode;
  title?: string;
  icon?: ReactNode;
};

export function SettingsEmptyState({
  children,
  action,
  title,
  icon,
}: SettingsEmptyStateProps) {
  const description =
    typeof children === 'string' ? (
      <MetaDefault color="fg.neutral.muted">{children}</MetaDefault>
    ) : (
      children
    );

  if (title) {
    return (
      <EmptyState
        title={title}
        description={typeof children === 'string' ? children : undefined}
        icon={icon}
      >
        {typeof children === 'string' ? null : children}
        {action}
      </EmptyState>
    );
  }

  if (icon) {
    return (
      <VStack alignItems="center" gap={3} w="full" py={10}>
        <Box color="fg.neutral.disabled" display="flex">
          {icon}
        </Box>
        {description}
        {action}
      </VStack>
    );
  }

  return (
    <VStack alignItems="flex-start" gap={3} w="full" py={12}>
      {description}
      {action}
    </VStack>
  );
}
